import { Box, Stack, Typography } from '@mui/material';
import EmptySummary from '../../../assets/images/empty-summary.svg';
import { t } from 'i18next';

export const BlankSummary = () => {
  return (
    <Box data-role="report-empty-summary" sx={{ width: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
      <Stack sx={{ alignItems: 'center', textAlign: 'center', maxWidth: '32rem' }} spacing={1.5}>
        <EmptySummary role="img" title={t('blankReportSummary.title')} />
        <Typography sx={{ fontWeight: 500 }}>{t('blankReportSummary.title')}</Typography>
        <Typography variant="body2">{t('blankReportSummary.subtitle1')}</Typography>
        <Typography variant="body2">{t('blankReportSummary.subtitle2')}</Typography>
      </Stack>
    </Box>
  );
};
